import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import Select from 'react-select';

export default ({ListContasTel, DadCont, IdConta, ListContas, setAddList, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo, MsgDesativar}) => {
const [Nome, setNome] = useState("");
const [Titulo, setTitulo] = useState("Transferir Categoria");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [Conta, setConta] = useState("");
const [ContasNome, setContasNome] = useState("Geral");
const [ContasTel, setContasTel] = useState("Geral");
const [IdContRes, setIdContRes] = useState(IdConta);

useEffect(() => {
      //console.log(IdContRes)     
      }, [IdContRes])
  
   console.log(UsuariosContServ) 
  const criando = ()=>{
 
    if(ContasNome !== "Geral" ){
      if (navigator.onLine) {
        setLoading(true)     
        Api.TATransferirCategorias(UsuariosContServ, IdContRes, Dados, Nome, setUsuariosContServ, setMsgErro, setLoading, setAlertTipo, setAlert, setAddList);
 
       
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("Escolha  Uma Conta para Transferir as Categorias")
    }
    
  }
  
 const printValue1 = (target) => {
            console.log(target)
            for(let i in ListContas){
            
              if(ListContas[i].select === target.value){
              setConta(ListContas[i].id)
              }
            
            }
          }
   const printValue5 = (target) => {
        
           setIdContRes(target.value)
           setContasNome(target.label)
           setContasTel(target.Tel)
           }
           const printValue6 = (target) => {
            
           setIdContRes(target.value)
           setContasNome(target.Nome)
           setContasTel(target.label)
           }

        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                      <div className="callout callout-info">
            <h5><i className="fas fa-info" /> Nota:</h5>
           Crie uma Categoria para os exercicios!
          </div>
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="fas fa-bezier-curve" /> Categorias  
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                    {Loading  ?
                    <>
                      <Spinner 
                      size={64}
                      color={"#5d0bf7"}
                      sizeUnit={'px'} 
                      /><br />
                      </>
                      :
                      <>
                    <div className="col-12">
                        <Butao 
                        style={"btn .btn-sm btn-info"}
                        titulo={"Transferir"}
                        onClick={()=>criando()}
                        />  
                    </div><br />
                     {MsgErro !== "" &&
                    <>
                     <div class="alert alert-danger alert-dismissible">
                  
                        <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                        {MsgErro}
                      </div>
                    </>
                    }
                    </>
                    }
                     {DadCont === "Emp" &&
                                                   <>
                           
                        {ListContas.length !== 0 &&
                        <>
                    
                    <div  style={{width:250, marginBottom:10, marginLeft:5}}>
                      <Select
                        defaultValue={ContasNome}
                      onChange={(target) => printValue5(target)}
                      options={ListContas}
                      placeholder={"Escolha  o Nome "}
                    />    
                    
                  </div> 
                    <div  style={{width:250, marginBottom:10, marginLeft:5}}>
                      <Select
                        defaultValue={ContasTel}
                      onChange={(target) => printValue6(target)}
                      options={ListContasTel}
                      placeholder={"Escolha  o Telefone"}
                    />    
                    
                  </div> 
                    <strong>Conta</strong><br />
                  <string style={{marginBottom:10, marginLeft:5}}>Id: {IdContRes} </string><br />
                  <string style={{marginBottom:10, marginLeft:5}}>Cliente: {ContasNome} </string><br />
                   <string style={{marginBottom:10, marginLeft:5}}>Tel: {ContasTel}</string> 
                  </>
                      }
                        </>
      
                              }
                  <br />
                    <strong> Categorias</strong><br />
                      {UsuariosContServ.map((item, key)=>(
                        <>
                        <string>{item.Nome}</string><br/>
                        </>
                         ))}
                    <br />
                  </address>
                </div>
                
              </div>
              <div className="row no-print">
             
               
              
              </div>
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}